import Container from "../components/basicComponents/container";
import { useEffect, useState } from "react";
import Grid from "../components/grid";
import { useDispatch } from "react-redux";
import {
    getUsefulLinks,
    removeUsefulLink,
} from "../state-management/actions/useful-links-actions";
import GroupLink from "../components/groupe-link";
import UsefulLink from "../components/useful-links";
import {
    getUsefulLinkGroup,
    removeUsefulLinkGroup,
} from "../state-management/actions/useful-link-groups-actions";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import {
    setAlert,
    setAlertContext,
    setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import "../styles/input.css";
interface GroupLink {
    _id: string;
    group_name: string;
}

const Links = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [groupLink, setGroupLink] = useState<GroupLink[]>([]);
    const [serverUpdate, setServerUpdate] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getUsefulLinks()(dispatch);
            const group = await getUsefulLinkGroup()(dispatch);
            setGroupLink(group.data);
            setData(response.data);
        };
        dispatch(setRowStatus("clear id", false));
        fetchData();
    }, [serverUpdate]);

    const handleAlert = (status: boolean) => {
        if (status) {
            dispatch(setAlert(true));
            dispatch(setAlertSeverity("success"));
            dispatch(setAlertContext(" عملیات با موفقیت تکمیل شد"));
        }
    };

    const handleRemoveLink = async (id: string) => {
        try {
            const response = await removeUsefulLink(id)(dispatch);
            console.log("حذف موفق لینک:", response);
            setData((prevData) =>
                prevData.filter((item: any) => item._id !== id)
            );
            setServerUpdate((prev: any) => !prev);
            handleAlert(true);
        } catch (error) {
            console.log(error);
        }
    };
    const handleRemoveLinkGroup = async (id: string) => {
        try {
            const existedItem = data.find((item: any) => item.group_id === id);
            if (!existedItem) {
                const removeGroup = await removeUsefulLinkGroup(id)(dispatch);
                console.log("حذف موفق گروه لینک:", removeGroup);
                setGroupLink((prevData) =>
                    prevData.filter((item: any) => item._id !== id)
                );
                setServerUpdate((prev: any) => !prev);
                handleAlert(true);
            } else {
                dispatch(setAlert(true));
                dispatch(setAlertSeverity("warning"));
                dispatch(setAlertContext("در جدول لینک ها دارای آیتم است"));
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="flex flex-col gap-y-11 w-full">
            <div className=" flex flex-col">
                <div className="w-full">
                    <Container header="جدول گروه لینک ها">
                        <div className="flex flex-col gap-y-11 w-full">
                            <GroupLink
                                groupLink={groupLink}
                                data={data}
                                onDataUpdate={setGroupLink}
                                setServerUpdate={setServerUpdate}
                            />
                            <Grid
                                columns={[
                                    { headerName: "لینک", field: "group_name" },
                                ]}
                                pageSize={15}
                                pagination={true}
                                userData={groupLink}
                                editable={false}
                                btnHeader="عملیات"
                                editBtn={true}
                                deleteBtn={true}
                                handleDelete={handleRemoveLinkGroup}
                            />
                        </div>
                    </Container>
                </div>
                <div className="w-full">
                    <Container header="جدول لینک ها">
                        <div className="flex flex-col gap-y-11 w-full">
                            {" "}
                            <UsefulLink
                                groupName={groupLink}
                                data={data}
                                onDataUpdate={setData}
                                setServerUpdate={setServerUpdate}
                                serverUpdate={serverUpdate}
                            />
                            <Grid
                                columns={[
                                    {
                                        headerName: "گروه",
                                        valueGetter: (params: any) =>
                                            groupLink.find(
                                                (item: any) =>
                                                    item._id ===
                                                    params.data.group_id
                                            )?.group_name || "",
                                    },
                                    { headerName: "لینک", field: "link" },
                                    { headerName: "عنوان", field: "name" },
                                ]}
                                pageSize={15}
                                pagination={true}
                                userData={data}
                                editable={false}
                                btnHeader="عملیات"
                                editBtn={true}
                                deleteBtn={true}
                                handleDelete={handleRemoveLink}
                            />
                        </div>
                    </Container>
                </div>
            </div>
        </div>
    );
};

export default Links;
